import React, { useEffect, useMemo } from 'react'
import { RouteComponentProps } from 'react-router'
import { Dispatch } from 'redux'
import { IPublishedSearch } from '../../types/publishedSearch'
import { IGroup } from '../../types/group'
import { getGroups } from '../../actions/groups'
import { parseNestedQuery } from '../../services/search'
import { useSearch } from '../../hooks'
import { PrimaryThemeProvider } from '../../styles'
import { Main } from '../../layouts'
import {
  H1,
  PublishedGraphicsList,
  ControlledInfiniteScroll,
  SearchFilters,
  SortByDropdown,
  Breadcrumbs,
  DefaultBreadcrumbs,
} from '../../components'
import { TitleBlockWrapper } from './styled'

export interface IConsumerSearchPageConnectedProps {
  search: IPublishedSearch
  groupsList: IGroup[]
  groupsLoading: boolean
  groupsLoaded: boolean
  dispatch: Dispatch
}

const sortTypes = [
  { label: 'Relevance', value: 'relevance' },
  { label: 'Published Date', value: 'publishedDate' },
]

export const ConsumerSearchPage = ({
  location,
  search,
  groupsList,
  groupsLoading,
  groupsLoaded,
  dispatch,
}: IConsumerSearchPageConnectedProps & RouteComponentProps<{}>) => {
  const params = parseNestedQuery(location.search)
  const groupId = params.group || ''
  const group = useMemo(() => groupsList.find(({ name }) => name === groupId), [
    groupId,
    groupsList,
  ])
  const [takeNextChunk, updateFilters] = useSearch({
    search,
    location,
    groupId,
    isConsumer: true,
    dispatch,
  })

  useEffect(() => {
    if (!groupsLoaded && !groupsLoading) {
      dispatch(getGroups())
    }
  }, [dispatch, groupsList, groupsLoading, groupsLoaded])

  return (
    <PrimaryThemeProvider>
      <Main
        header={group ? <Breadcrumbs group={group} /> : <DefaultBreadcrumbs />}
        sidebarSecondary={
          <SearchFilters
            isConsumer
            theme="orange"
            groupId={groupId}
            groups={groupsList}
            setFilters={updateFilters}
          />
        }
        titleBlock={
          <TitleBlockWrapper>
            <H1>Search results</H1>
            <SortByDropdown
              filterValues={params}
              sortTypes={sortTypes}
              updateFilters={updateFilters}
            />
          </TitleBlockWrapper>
        }
        helmet={`Reuters Graphics. Portal: ${
          group ? group.shortTitle : 'All groups'
        }`}
      >
        <ControlledInfiniteScroll
          component={PublishedGraphicsList}
          takeNextChunk={takeNextChunk}
          search={search}
        />
      </Main>
    </PrimaryThemeProvider>
  )
}
